const templates = {
  homepageJazzFestival: 'V2',
};

export const templateMachetes = (templateName: string) => {
  return templates[templateName] || '';
};
